module.exports = __webpack_public_path__ + "static/media/Buho_somos02.a28ffbef.svg";